import type { TOC } from '@ember/component/template-only';
import type { EmployeeExtension as EmployeeModel } from 'tio-data/data/resources/employee.ext';
import type { AccountingPaymentExtension as AccountingPaymentModel } from 'tio-data/data/resources/accounting-payment.ext';
import BaseAccountingPayments from 'tio-common/components/contributions/accounting-payments';
import Table from './accounting-payments/table';
import Summary from 'tio-common/components/contributions/accounting-payments/summary';
import { hash } from '@ember/helper';

interface AccountingPaymentsSummaryData {
  total?: number | null;
}

export interface ContributionsAccountingPaymentsSignature {
  Args: {
    employee: EmployeeModel;
  };
  Blocks: {
    default: [
      {
        isLoaded: boolean;
        paymentData: AccountingPaymentModel[];
        summaryData: AccountingPaymentsSummaryData;
        table: unknown;
        summary: unknown;
      },
    ];
  };
}

const ContributionsAccountingPaymentsComponent: TOC<ContributionsAccountingPaymentsSignature> =
  <template>
    <BaseAccountingPayments @employee={{@employee}} as |base|>
      {{yield
        (hash
          paymentData=base.paymentData
          summaryData=base.summaryData
          isLoaded=base.isLoading
          table=(component Table model=base.paymentData isLoading=base.isLoading)
          summary=(component Summary model=base.summaryData isLoading=base.isLoading)
        )
      }}
    </BaseAccountingPayments>
  </template>;

export default ContributionsAccountingPaymentsComponent;
